import React from "react";
import { ButtonContainer } from "./styles";

function Button({ text, onClick, variant = "primary", width="fit-content" }) {
  return (
    <ButtonContainer variant={variant} onClick={onClick} width={width}>
      {text}
    </ButtonContainer>
  );
}
export default Button;
